import i18n from 'i18next'; /* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Grid,
  Container,
  InputAdornment,
  Link,
  TextField,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  makeStyles,
  Typography,
  Autocomplete,
  Alert,
  MenuItem } from
  '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PostAddIcon from '@material-ui/icons/PostAdd';
import SearchIcon from '../../../icons/Search';
import PropTypes from 'prop-types';
import commonService from '../../../services/commonService';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
}));

const SelectProduct = (props) => {
  const { selectProduct, createNew, formSubmitFlag } = props;
  const [value, setValue] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  const intervalId = useRef(null);

  const search = (key) => {
    setIsLoading(true);
    commonService.getProductByKey(key).then((response) => {
      if (response) {
        setResults(response);
      }
      setIsLoading(false);
    });
  };

  const classes = useStyles();
  const [modalState, setModalState] = useState({
    isOpen: false,
    type: 'create',
    title: ''
  });

  const closeModal = () => setModalState({
    ...modalState,
    isOpen: false
  });

  const onClikNewItem = () => {
    createNew(value);
    setValue(value);
  };

  useEffect(() => {
    if (intervalId.current) {
      clearTimeout(intervalId.current);
    }
    intervalId.current = setTimeout(() => {
      if (value.length > 1) {
        search(value);
      }
    }, 250);
  }, [value]);

  useEffect(() => {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!formSubmitFlag) {
      setValue('');
    }
  }, [formSubmitFlag]);

  return (
    <Box sx={{ pt: 3 }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={1}
          style={{ marginTop: '20px' }}
        >

          <Grid
            xs={8}
            sm={10}
            sx={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
              gap: 3,
              justifyContent: 'center'
            }}
            style={{ paddingRight: '10px' }}
            className="tp-oc-search-wrapper"
          >

            <Autocomplete
              value={selectedProduct}
              onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                  setSelectedProduct({ name: newValue });
                } else {
                  selectProduct(results, newValue);
                  setSelectedProduct(newValue);
                }
              }}
              options={results}
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Regular option
                return option.name;
              }}
              loading={isLoading}
              loadingText="Yükleniyor.."
              inputValue={value}
              filterOptions={(opt, { inputValue }) => {
                if (!isLoading && value && opt.length === 0) {
                  setResults([{
                    id: inputValue,
                    name: inputValue,
                    isNew: true
                  }]);
                }
                return opt;
              }}
              onInputChange={(event) => {
                if (!event) {
                  setValue(selectedProduct?.name);
                  return;
                }
                setValue(event.target.value);
              }}
              renderOption={(p, option) => (
                <MenuItem
                  {...p}
                  onClick={!option.isNew ? p.onClick : onClikNewItem}
                >

                  {!option.isNew && option.name}
                  {option.isNew && option.name
                && (
                <Box sx={{ display: 'flex', flexFlow: 'row nowrap', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                  <PostAddIcon />
                  <Typography>
                    <Link>{option.name}</Link>
                    {' '}
                    {i18n.t('SelectProduct.ad\u0131nda_yeni_bir_\xFCr\xFCn_eklemek_i\xE7in_t\u0131klay')}

                  </Typography>
                </Box>
                )}
                </MenuItem>
              )}
              noOptionsText={isLoading ? '...' : !value ? 'Ürün aramak için yazmaya başlayın' : 'Aradığınız Ürün bulunamadı'}
              autoComplete
              includeInputInList
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className="tp-adornment__custom"
                  style={{ minWidth: '200px' }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment:
  <InputAdornment position="start">
    <SearchIcon fontSize="small" />
  </InputAdornment>

                  }}
                  placeholder={i18n.t('SelectProduct.\xFCr\xFCn_hizmet_kategori_ara')}
                />
              )}
              fullWidth
            />

            <Alert
              severity="error"
              className="tp-oc-alert"
            >
              {i18n.t('SelectProduct.l\xFCtfen_arad\u0131\u011F\u0131n\u0131z_\xFCr\xFCn_veya_hizmetin_gen')}

              {' '}
              <strong>{i18n.t('SelectProduct.\xF6rne\u011Fin')}</strong>
              {' '}
              {i18n.t('SelectProduct.ucf_208_rulman_i\xE7in_ihale_a\xE7acaksan\u0131z_ar')}

              {' '}
              <strong>{i18n.t('SelectProduct.rulman')}</strong>
              {' '}
              {i18n.t('SelectProduct.yaz\u0131n_detaylar\u0131_a\u015Fa\u011F\u0131da_a\xE7\u0131lan_kutucukla')}

            </Alert>
          </Grid>
          <Grid
            xs={4}
            sm={2}
            sx={{
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center',
              gap: 3,
              justifyContent: 'center'
            }}
          >

            <Tooltip
              title={i18n.t('SelectProduct.yeni_i_hale_nas\u0131l_a\xE7\u0131l\u0131r')}
              className="tp-new-order-modal"
            >

              <Button
                variant="outlined"
                onClick={() => {
                  setModalState({
                    isOpen: true
                  });
                }}
                type="button"
                color="secondary"
                className="tp-btn__how-to-open-bid tp-btn-yellow-dark"
                startIcon={<LiveHelpIcon />}
                size="large"
                sx={{
                  whiteSpace: 'nowrap'
                }}
                style={{ minWidth: '200px' }}
              >
                {i18n.t('SelectProduct.yeni_i_hale_nas\u0131l_a\xE7\u0131l\u0131r')}

              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        <Dialog
          onClose={closeModal}
          aria-labelledby="customized-dialog-title"
          open={modalState.isOpen}
          className="tp-how-new-order__modal"
        >

          <DialogTitle
            id="customized-dialog-title"
            onClose={closeModal}
          >

            <b>{i18n.t('SelectProduct.yeni_i_hale_nas\u0131l_a\xE7\u0131l\u0131r')}</b>
            <IconButton
              aria-label={i18n.t('SelectProduct.close')}
              className={classes.closeButton}
              onClick={closeModal}
            >

              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography>
              <p>
                <strong>
                  {i18n.t('SelectProduct.\xFCr\xFCn_ve_hizmet_detay\u0131')}

                </strong>
                {i18n.t('SelectProduct.\xFCr\xFCn_ve_hizmet_detay\u0131_k\u0131sm\u0131na_fiyat_alma')}

              </p>
              <p>
                {i18n.t('SelectProduct.marka_miktar_gibi_hususlar\u0131_kendi_h\xFCcrel')}

              </p>
              <p>
                <strong>
                  {i18n.t('SelectProduct.\xF6rne\u011Fin')}

                </strong>
                {i18n.t('SelectProduct.100_adet_ucf_208_yatakl\u0131_rulman_ve_50_ad')}

              </p>
              <p>
                {i18n.t('SelectProduct.i_ki_\xFCr\xFCnde_rulman_ancak_farkl\u0131_rulman_\xE7')}

              </p>
              <p>
                {i18n.t('SelectProduct.i_ki_\xFCr\xFCn\xFC_de_ayn\u0131_sat\u0131rda_belirterek_ih')}

              </p>
              <p>
                <strong>
                  {i18n.t('SelectProduct.sat\u0131r_1')}

                </strong>
                {i18n.t('SelectProduct.ucf_208_yatakl\u0131_rulman_fiyat_teklifi_alm')}

              </p>
              <p>
                <strong>
                  {i18n.t('SelectProduct.sat\u0131r_2')}

                </strong>
                {i18n.t('SelectProduct.ucf_206_yatakl\u0131_rulman_fiyat_teklifi_alm')}

              </p>
              <ul>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.marka')}

                  </strong>
                  {i18n.t('SelectProduct.i_hale_olu\u015Ftururken_marka_bildirmek_zoru')}

                </li>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.miktar')}

                  </strong>
                  {i18n.t('SelectProduct.ne_kadar_\xFCr\xFCn_almak_istiyorsan\u0131z_onu_yaz')}

                </li>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.\xF6deme_t\xFCr\xFC')}

                  </strong>
                  {i18n.t('SelectProduct.i_hale_a\xE7arken_almak_istedi\u011Finiz_\xFCr\xFCn\xFCn_')}

                </li>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.termin_s\xFCresi')}

                  </strong>
                  {i18n.t('SelectProduct.sat\u0131n_almak_istedi\u011Finiz_\xFCr\xFCn\xFCn_ne_kadar_')}

                </li>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.i_hale_s\xFCresi')}

                  </strong>
                  {i18n.t('SelectProduct.a\xE7m\u0131\u015F_oldu\u011Funuz_ihalenin_sistemde_kalaca')}

                </li>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.a\xE7\u0131lan_ihalede_ad\u0131m\u0131_gizle')}

                  </strong>
                </li>
              </ul>
              <p>
                {i18n.t('SelectProduct.bu_se\xE7ene\u011Fi_kullanarak_ihale_a\xE7t\u0131\u011F\u0131n\u0131zda')}

              </p>
              <ul>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.fiyat_teklifi_almak_istedi\u011Finiz_favori_f')}

                  </strong>
                </li>
              </ul>
              <p>
                {i18n.t('SelectProduct.bu_se\xE7ene\u011Fi_kullanarak_a\xE7t\u0131\u011F\u0131n\u0131z_ihaleyi')}

                <a
                  href="https://joobid.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {i18n.t('SelectProduct.https_joobid_com')}

                </a>
                {i18n.t('SelectProduct.ihaleniz_ile_ilgili_se\xE7mi\u015F_oldu\u011Funuz_ted')}

              </p>
              <ul>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.a\xE7\u0131lan_ihalede_ad\u0131m\u0131_gizle_1')}

                  </strong>
                </li>
              </ul>
              <p>
                {i18n.t('SelectProduct.bu_se\xE7ene\u011Fi_kullanarak_ihale_a\xE7t\u0131\u011F\u0131n\u0131zda_1')}

              </p>
              {/* <ul>
                 <li>
                   <strong>
                     Bu ihaleyi ileri tarihte başlat
                   </strong>
                 </li>
                </ul>
                <p>
                 İleri bir tarihte aktif olacak bir ihale oluşturmak istiyorsanız bu sekmeyi kullanabilirsiniz. İleri tarihe planladığınız ihaleniz seçtiğiniz tarihte görünür olacaktır.
                </p> */}
              <ul>
                <li>
                  <strong>
                    {i18n.t('SelectProduct.proje_ad\u0131')}

                  </strong>
                </li>
              </ul>
              <p>
                {i18n.t('SelectProduct.daha_sonraki_zamanlarda_belirli_bir_proj')}

              </p>
              <p>
                <strong>
                  {i18n.t('SelectProduct.\xF6rnek')}

                </strong>
                {i18n.t('SelectProduct.x_projeniz_i\xE7in_al\u0131m_ihaleleri_a\xE7acaks\u0131n')}

              </p>
              <p>
                <strong>
                  {i18n.t('SelectProduct.i_hale_a\xE7')}

                </strong>
                {i18n.t('SelectProduct.h\xFCcreleri_doldurduktan_sonra')}

                <strong>
                  {i18n.t('SelectProduct.i_hale_a\xE7_olu\u015Ftur')}

                </strong>
                {i18n.t('SelectProduct.butonuna_t\u0131klayarak_yeni_ihale_a\xE7ma_s\xFCre')}

              </p>
            </Typography>
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default SelectProduct;

SelectProduct.propTypes = {
  selectProduct: PropTypes.func.isRequired,
  createNew: PropTypes.func.isRequired,
  formSubmitFlag: PropTypes.any
};
